export default __webpack_public_path__ + "static/media/android-apk.2cbe369d.svg";